<template>
    <div class="">
        <InfoPopup ref="rolesPopup">
            <RolesMultilanguage>
            </RolesMultilanguage>
        </InfoPopup>

        <user-modal
            :user="currentUser"
            :is-reseller="false"
            :validate-user-limits="true"
            :company="company"
            :current-users="users"
            :outside-users="outsideUsers"
            :outside-role-ids="outsideRoleIds"
            :own-role-id="ownCompany ? ownCompany.role : null"
            @userSaved="closeEditUserModal"
        />


        <div class="users-page-header col-12" v-if="company">
            <div class="col-4">
                Group name: <span>{{ company.name }}</span>
            </div>
            <div class="col-4">
                Billed users count: <span :class="activeUserCount >= company.max_number_of_users ? 'user-limit-full' : ''">{{
                    activeUserCount
                }} / {{ company.max_number_of_users }}</span>
            </div>
        </div>

        <template v-if="users.length !== 0">
            <div>
                <users-table
                    addButtonText="Add user"
                    :company="company"
                    :users="users"
                    :max-users="company.max_number_of_users"
                    :can-add-user="hasOwnPermission('add_user')"
                    :can-edit-user="canEdit"
                    :can-delete-user="canDelete"
                    @create-user="showCreateUserModal"
                    @edit-user="editUser"
                    @delete-user="confirmDeleteUser"
                    @restore-user="confirmRestoreUser"
                    @show-roles-info="openRolesPopup"
                >
                     <template #modals>
                        <b-modal
                            id="remove-user-modal"
                            centered
                            size="lg"
                            title="Remove user"
                            @ok="deleteUser"
                        >
                            <p class="my-4">Are you sure you want to delete this user?</p>
                        </b-modal>

                         <b-modal
                             id="restore-user-modal"
                             centered
                             size="lg"
                             title="Restore user"
                             @ok="restoreUser"
                         >
                             <p class="my-4">Are you sure you want to restore this user?</p>
                         </b-modal>
                    </template>
                </users-table>
            </div>
        </template>



        <div class="users-page-header col-12" v-if="company && company.max_number_of_outside_users > 0">
            <div class="col-4">
                Outside users count: <span :class="activeOutsideUserCount >= company.max_number_of_outside_users ? 'user-limit-full' : ''">{{
                    activeOutsideUserCount
                }} / {{ company.max_number_of_outside_users }}</span>
            </div>
        </div>

        <template v-if="company && company.max_number_of_outside_users > 0">
            <div class="mb-5">
                <users-table
                    addButtonText="Add outside user"
                    :company="company"
                    :users="outsideUsers"
                    :max-users="company.max_number_of_outside_users"
                    :can-add-user="hasOwnPermission('add_user')"
                    :can-edit-user="canEdit"
                    :can-delete-user="canDelete"
                    @create-user="showCreateUserModal"
                    @edit-user="editUser"
                    @delete-user="confirmDeleteUser"
                    @restore-user="confirmRestoreUser"
                    @show-roles-info="openRolesPopup"
                >
                </users-table>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import Verte from 'verte';
import 'verte/dist/verte.css';
import '@css/users.css';
import axios from "axios";
import UserModal from "../../reseller/components/Companies/Parts/UserModal";
import InfoPopup from '@components/common/PopupModal.vue';
import moment from "moment/moment";
import UsersTable from './parts/UsersTable.vue'
import PrintPopup from "@components/common/PopupModal.vue";
import RolesMultilanguage from "@components/common/RolesMultilanguage.vue";
import {OUTSIDE_ROLE_IDS} from "@js/manager"


Vue.component('verte', Verte);

export default {
    components: {PrintPopup, UserModal, InfoPopup, RolesMultilanguage,UsersTable},
    comments: {Verte},
    data() {
        return {
            company: null,
            users: [],
            outsideUsers: [],
            outsideRoleIds : OUTSIDE_ROLE_IDS,
            ownCompany: null,
            roles: [],
            projects: [],
            currentUser: {
                id: null,
                name: null,
                email: null,
                unique_id: null,
                color: null,
                password: null,
                confirm_password: null,
                role: {
                    id: '',
                    name: ''
                },
                assigned_projects: []
            },
            createUserStep: 1,
            errors: [],
            isCreateUserModalVisible: false,
        }
    },
    mounted() {
        this.refreshOwnCompany();
        this.load();
    },
    computed: {
        activeUserCount() {
            return this.users.filter(user => !user.is_deleted).length;
        },
        activeOutsideUserCount() {
            return this.outsideUsers.filter(user => !user.is_deleted).length;
        },
        // Own role in the company being viewed (not the last opened project's company).
        ownRoleId() {
            return this.ownCompany ? this.ownCompany.role : 9999;
        }
    },
    methods: {
        load() {
            this.loadCompany();
            this.loadCompanies();
            this.loadUsers();
            this.loadRoles();
            this.loadProjects();
        },
        loadCompany() {
            if (!this.$route.params.company_id) {
                return;
            }

            this.$store.state.company.id = this.$route.params.company_id;

            this.$store.dispatch('loadCompany').then((company) => {
                this.company = company;
            });
        },
        loadCompanies() {
            if (!this.$route.params.company_id) {
                return;
            }

            this.$store.dispatch('loadCompanies').then(companies => {
                this.$store.state.companies = companies;
                this.refreshOwnCompany();
            });
        },
        // The store comes from the shared mobile bundle and its changes do not re-render
        // this page, so keep our own copy of "my membership in this company". Without it a
        // direct page load showed no edit buttons until the companies happened to be cached.
        refreshOwnCompany() {
            this.ownCompany = this.getUserCompany(this.$route.params.company_id) || null;
        },
        hasOwnPermission(permission) {
            return !!(this.ownCompany && this.ownCompany.permissions.manager.projects[permission]);
        },
        loadUsers() {
            if (!this.$route.params.company_id) {
                return;
            }
            this.$store.dispatch('loadUsers').then((users) => {
                this.outsideUsers = users.filter(user => user.role && this.isOutsideUser(user));
                this.users = users.filter(user => !user.role || !this.isOutsideUser(user));
            });
        },
        loadRoles() {
            this.$store.dispatch('loadRoles').then((roles) => {
                this.roles = roles;
            });
        },
        loadProjects() {
            if (!this.$store.state.project.id) {
                return;
            }
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/projects',
                method: 'GET',
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.projects = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        showCreateUserModal() {
            this.createUserStep = 1;
            this.resetCurrentUser();

            this.$bvModal.show('userModal');

        },
        openRolesPopup() {
            this.$refs.rolesPopup.openPopup();
        },

        confirmDeleteUser(user) {
            this.currentUser = {...user};

            this.$bvModal.show('remove-user-modal');
        },
        confirmRestoreUser(user) {
            this.currentUser = {...user};

            this.$bvModal.show('restore-user-modal');
        },
        deleteUser() {
            const token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/users/' + this.currentUser.id,
                method: 'DELETE',
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.$bvModal.hide('remove-user-modal');
                    this.load();
                })
                .catch(error => {
                    if (error.response?.data?.message) {
                        alert(error.response.data.message);
                    }

                    console.log(error);
                });
        },
        restoreUser() {
            const token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/users/restore/' + this.currentUser.id,
                method: 'GET',
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.$bvModal.hide('restore-user-modal');
                    this.load();
                })
                .catch(error => {

                    if (error.response.data.message) {
                        this.$bvModal.msgBoxOk(error.response.data.message);
                    } else {
                        alert('Something went wrong');
                    }
                    console.log(error);
                });
        },
        editUser(user) {
            this.createUserStep = 1;
            this.currentUser = {...user};
            this.currentUser.password = null;
            this.currentUser.confirm_password = null;

            this.$bvModal.show('userModal');
        },

        resetCurrentUser() {
            this.currentUser = {
                id: null,
                name: null,
                email: null,
                unique_id: null,
                color: "#dc3545",
                password: null,
                confirm_password: null,
                role: {
                    id: '',
                    name: ''
                },
                assigned_projects: []
            };
            this.createUserStep = 1;

        },
        lastUpdated(user) {
            return moment.utc(user.updated_at).fromNow();
        },
        projectChange(event, project) {
            if (event.target.checked) {
                this.currentUser.assigned_projects.push(project);
            } else {
                this.currentUser.assigned_projects = this.currentUser.assigned_projects.filter(function (obj) {
                    return obj.id !== project.id;
                });
            }
        },
        saveUser(event) {
            event.preventDefault();

            this.errors = [];

            if (!this.currentUser.name) {
                this.errors.push("Name required.");
            }

            if (!this.currentUser.email) {
                this.errors.push("Email  required.");
            } else if (!this.validEmail(this.currentUser.email)) {
                this.errors.push('Valid email required.');
            }

            if (!this.currentUser.role.id) {
                this.errors.push("Role required.");
            }

            if (!this.currentUser.id) {
                if (!this.currentUser.password) {
                    this.errors.push("Password  required.");
                }
                if (!this.currentUser.confirm_password) {
                    this.errors.push("Password confirmation required.");
                }
            }

            if (this.currentUser.password !== this.currentUser.confirm_password) {
                this.errors.push("Passwords don't match.");
            }


            if (this.currentUser.password) {
                const lowerCaseLetters = /[a-z]/g;
                const upperCaseLetters = /[A-Z]/g;
                const numbers = /[0-9]/g;

                if (this.currentUser.password.length < 8 || !this.currentUser.password.match(lowerCaseLetters)
                    || !this.currentUser.password.match(upperCaseLetters) || !this.currentUser.password.match(numbers)) {
                    this.errors.push("The password must be at least 8 characters long, must contain both lower- and uppercase letters and numbers.");
                }

            }


            if (!this.errors.length) {
                const token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/users',
                    data: this.currentUser,
                    method: 'POST',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.$bvModal.hide('userModal');
                        this.load();
                    })
                    .catch((error) => {
                        if (error.response && error.response.data && error.response.data.errors) {

                            for (const [key, value] of Object.entries(error.response.data.errors)) {
                                this.errors.push(value);
                                console.log(`${key}: ${value}`);
                            }
                        }
                        console.log(error, 'err');
                    });
            }

        },
        closeEditUserModal() {
            this.resetCurrentUser();
            this.load();
            this.$bvModal.hide('userModal');
        },
        validEmail: function (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        canAddUser(isOutsideUser = false) {
            if (!this.company) {
                console.log('no company');
                return false;
            }

            const currentCount = isOutsideUser ? this.activeOutsideUserCount : this.activeUserCount;

            const maxCount = isOutsideUser ?
                this.company.max_number_of_outside_users :
                this.company.max_number_of_users;
            console.log('currentCount', currentCount, maxCount);
            return currentCount < maxCount;
        },


        canEdit(user) {
            if (this.hasOwnPermission('add_user')) {
                const ownRoleId = this.ownRoleId;
                // Admins can always edit other admins.
                if (user.role.id === 1) {
                    return ownRoleId === 1;
                }
                // User can only edit accounts with less powerful roles.
                return user.role.id > ownRoleId;
            }

            return false;
        },

        canDelete(user) {
            if (this.hasOwnPermission('delete_user')) {
                const ownRoleId = this.ownRoleId;

                // User cannot delete his/her own account.
                if (user.id === this.$store.state.user.id) {
                    return false;
                }

                // Admins can always delete other admins.
                if (user.role.id === 1) {
                    return ownRoleId === 1;
                }

                // User can only delete accounts with less powerful roles.
                return user.role.id > ownRoleId;
            }
            return false;
        },
    },
    watch: {}

}
</script>

<style scoped>
.last-updated {
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 4px;
    cursor: default;
}
</style>
